import './CoralGrantsFundingSingleCard.scss'

import { useIsWindowBiggerThan } from '@bob/library'
import { CoralHeading } from '@websrc/App/Components/CoralHeading/CoralHeading'
import { CoralMasterCardVisuals } from '@websrc/DataMappers/mapCoralMasterCard'
import { mapCoralWebGrantsFundingSingleCard } from '@websrc/DataMappers/mapSpot'
import React, { FC, useMemo } from 'react'

import { CoralMasterCard } from '../../../coral-library/cards/Coral/ContentCard/CoralMasterCard'

type CoralTeacherResourcesCardsProps = ReturnType<typeof mapCoralWebGrantsFundingSingleCard>

const smVisuals: CoralMasterCardVisuals = {
  headlineSize: 'h2-sm',
  contentContainerColor: 'off-white',
  contentPadding: '4xl',
  bodySize: 'body-md',
  paddingBody: '2xl',
  positionContent: 'center',
  imageOrientation: 'top',
  equalSize: true,
  radius: 4,
}

const lgVisuals: CoralMasterCardVisuals = {
  headlineSize: 'h2-sm',
  contentContainerColor: 'off-white',
  contentPadding: '4xl',
  bodySize: 'body-md',
  paddingBody: '2xl',
  positionContent: 'center',
  imageOrientation: 'left',
  imageRatio: '5-4',
  equalSize: true,
  radius: 4,
}

export const CoralGrantsFundingSingleCard: FC<CoralTeacherResourcesCardsProps> = (props) => {
  const isDesktop = useIsWindowBiggerThan(1439)

  const baseVisuals = useMemo(() => (isDesktop ? lgVisuals : smVisuals), [isDesktop])

  const visuals: CoralMasterCardVisuals = useMemo(() => {
    const copy = { ...baseVisuals }
    if (copy.imageOrientation === 'left') if (props.reverseImage) copy.imageOrientation = 'right'
    return copy
  }, [baseVisuals, props.reverseImage])

  return (
    <div className={'category-coral-spot'}>
      <div className={'coral-grants-funding-single-card'}>
        <CoralHeading
          cta={props.cta}
          description={props.description}
          header={props.header}
          headerTag={'0'}
        />
        <div className={'coral-grants-funding-single-card__card'}>
          <CoralMasterCard visuals={visuals} {...props.card} />
        </div>
      </div>
    </div>
  )
}
